var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M7.5 16.5H10.125M13.875 16.5H16.5M20.25 20.25V12.75H15.75L9.75 8.25V12.75L3.75 8.25V20.25M1.5 20.248H22.5", stroke: "#303030", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M20.2503 12.75L18.8423 2.89393C18.8168 2.71521 18.7277 2.5517 18.5913 2.43341C18.4549 2.31512 18.2804 2.25 18.0999 2.25H16.4008C16.2203 2.25 16.0458 2.31512 15.9094 2.43341C15.773 2.5517 15.6839 2.71521 15.6584 2.89393L14.3955 11.7339", stroke: "#303030", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});